export const FORM_OPTION_SOURCE_MANUAL = 'manual';
export const FORM_OPTION_SOURCE_LINK_ITEMS = 'linkItems';
export const FORM_OPTION_SOURCE_MANUAL_AND_LINK_ITEMS = 'manualAndLinkItems';

export const normaliseOptionList = (value) => (
  Array.isArray(value)
    ? value.map((item) => String(item).trim()).filter(Boolean)
    : String(value || '').split(/\r?\n|,/).map((item) => item.trim()).filter(Boolean)
);

const labelForLinkItem = (item = {}, index) => (
  item.title
  || item.name
  || item.description
  || item.id
  || `Item ${index + 1}`
);

export const optionsForLinkItems = (items = []) => (
  items.map(labelForLinkItem).map((option) => String(option).trim()).filter(Boolean)
);

export const resolveFieldOptions = (field = {}, linkItems = []) => {
  const manualOptions = normaliseOptionList(field.options || []);
  const itemOptions = optionsForLinkItems(linkItems);
  const optionSource = field.optionSource || FORM_OPTION_SOURCE_MANUAL;

  if (optionSource === FORM_OPTION_SOURCE_LINK_ITEMS) {
    return [...new Set(itemOptions)];
  }

  if (optionSource === FORM_OPTION_SOURCE_MANUAL_AND_LINK_ITEMS) {
    return [...new Set([...manualOptions, ...itemOptions])];
  }

  return [...new Set(manualOptions)];
};
